import "./ContactPage.css";

function ContactPage() {
  return (
    <div className="contact">
      <h1>Reach Us</h1>

      <div className="contact-info">
        <p><strong>Powai, Mumbai</strong></p>
        <p><strong>Defence Colony, New Delhi</strong></p>

        <p>
          Email: <a href="mailto:sampark@kropsindia.com">sampark@kropsindia.com</a>
        </p>

        <p>
          Phone: +91 9868 10 6363 / +91 7400 34 1134
        </p>

        <div className="social-links">
         
         <a
  href="https://www.linkedin.com/in/krops-india-5b33911b5/"
  target="_blank"
  rel="noopener noreferrer"
>
  LinkedIn
</a>

<a
  href="https://www.facebook.com/krops.india"
  target="_blank"
  rel="noopener noreferrer"
>
  Facebook
</a>

        
        </div>
      </div>

      <form className="contact-form">
        <h2>Send Us a Message</h2>

        <input type="text" placeholder="Your Name" required />
        <input type="email" placeholder="Your Email" required />
        <input type="tel" placeholder="Your Phone Number" required />
        <textarea placeholder="Your Message" rows="5" required />

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default ContactPage;
